import { categories } from '@/mocks/videos';

interface CategoryTabsProps {
  active: string;
  onChange: (slug: string) => void;
}

export default function CategoryTabs({ active, onChange }: CategoryTabsProps) {
  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <div className="flex items-center gap-1 px-1 py-1 min-w-max">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => onChange(cat.slug)}
            className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer font-medium ${
              active === cat.slug
                ? 'bg-primary-500 text-white'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>
    </div>
  );
}